const REDIRECT = {
  path: '/middle/upload',
  name: 'middle',
  component: () => import('@/views/redirect/upload/index.vue'),
  meta: {
    requiresAuth: true,
    hideInMenu: true
  }
};

export default REDIRECT;
